<template>
  <div class="users">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>检测单短信通知</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/msmnotification/create')"
          >添加</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="5">&nbsp;</el-col>
        <el-col :span="5">
          <el-input
            placeholder="请输入公司名称"
            v-model="companyName"
            clearable
            class="input-with-select"
          >
          </el-input>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="5">
          <el-input
            placeholder="请输入姓名"
            v-model="name"
            clearable
            class="input-with-select"
          >
          </el-input>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="5">
          <el-input
            clearable
            placeholder="请输入手机号"
            v-model="phone"
            class="input-with-select"
          >
          </el-input>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>

        <el-col :span="1">
          <el-button
            icon="el-icon-search"
            type="primary"
            plain
            @click="getMsmList"
          ></el-button>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="msmList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      v-if="deviceTypeList.length > 0"
      :state="editState"
      @close="editState = false"
      :editData="editData"
      :deviceTypeList="deviceTypeList"
      @confirm="changeData"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit.vue'
import { brequest } from '@/utils/brequest'
import { msmList, updateMsm, deleteMsm } from '@/api/detection'
//  addMsm,
export default {
  components: {
    TzTable,
    Edit
  },
  methods: {
    async getMsmList() {
      let ret = await brequest({
        url: '/check/querySysData?dataType=equipment_type',
        data: {}
      })
      if (ret) {
        this.deviceTypeList = ret
        // console.log('设备类型', this.deviceTypeList)
        var data = {
          companyName: this.companyName,
          name: this.name,
          phone: this.phone,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        msmList(data).then((res) => {
          res.data.records.forEach((item) => {
            // 变成数组
            let deviceType = item.deviceType.split(',')
            item.deviceType = deviceType
            deviceType = deviceType.map((rec) => {
              return ret.find((item) => item.value === rec).label + '，'
            })

            item.deviceTypeText = deviceType.join('').slice(0, -1)
            if (!item.phone) {
              item.phone = '/'
            }
            if (!item.companyName) {
              item.companyName = '/'
            }
          })
          this.msmList = res.data.records
          this.total = res.data.total
        })
      }
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.getMsmList()
      this.$forceUpdate()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getMsmList()
      this.$forceUpdate()
    },
    deleteFn(row) {
      // console.log('删除2', row)

      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteMsm(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    deleteMsm(row) {
      this.$loading({
        text: '数据删除中'
      })
      deleteMsm({ id: row.id }).then((res) => {
        this.$loading().close()
        if (res) {
          // this.msmList = this.msmList.filter((rec) => rec.id !== row.id)
          this.$message({
            message: '数据删除成功',
            type: 'success'
          })
          this.getMsmList()
        }
      })
    },
    changeData(data) {
      this.$loading({
        text: '数据更新中'
      })
      data.deviceType = data.deviceType.join(',')
      updateMsm(data).then((res) => {
        this.$loading().close()
        if (res) {
          this.editState = false
          this.$message({
            message: '数据更新成功',
            type: 'success'
          })
          this.getMsmList()
          //  this.msmList.find((rec) => rec.id === data.id).rightText = data.rightText
        }
      })
    }
  },
  data() {
    return {
      // 编辑表单数据
      editState: false,
      editData: {},
      deviceTypeList: [],
      // 筛选模型
      // offset: '', //当前起始位置（page-1）*limit
      pageNum: 1, //当前页
      pageSize: '10', //
      total: 0, //总条数
      phone: '',
      name: '',
      companyName: '',
      // 表格列
      columns: [
        { title: '公司名称', field: 'companyName' },
        { title: '设备类型', field: 'deviceTypeText' },
        { title: '姓名', field: 'name' },
        { title: '手机', field: 'phone' },

        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('修改', row)
                this.editData = JSON.parse(JSON.stringify(row))
                // 1 显示弹框
                this.editState = true
                // 2.
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => this.deleteFn(row)
            }
          ]
        }
      ],
      // 表格数据
      msmList: []
    }
  },
  mounted() {
    // this.querySysDataFn()
    this.getMsmList()
  }
}
</script>

<style lang="scss" scoped>
// history
// .history {
// }
</style>
